import { FundingSource } from "admin/types/interfaces/funding";
import { SWRConfiguration } from "swr";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_ACCESS_CONTROLLER_API } = import.meta.env;

const useFundingSources = (enabled = true, options?: SWRConfiguration) => {
  const url = enabled ? `${VITE_ACCESS_CONTROLLER_API}/funding-sources?limit=500` : null;
  return useFetcher<FundingSource[]>(url, { shouldCamelize: true, ...options });
};

export default useFundingSources;
